import executeSeeds from "./execute-seeds.js";
import syncLocales from "./sync-locales.js";

export default {
	executeSeeds,
	syncLocales,
};
